import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`1. Not able to access openshift cluster`}</h3>
    <p>{`Openshift URL’s might not be accessible from within SI corporate network if it is not whitelisted. Please log out of the corporate VPN and retry.`}</p>
    <h3>{`2. Getting access to slack channel and joining it.`}</h3>
    <ul>
      <li parentName="ul">{`Create a slack account using the enterprise email ID `}</li>
      <li parentName="ul">{`You would get a mail with the subject “XXX has invited you to join a Slack workspace”. It would contain a link/button to join the IBM-Cognitive-Applications workspace managed by IBM.`}</li>
    </ul>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "63.19444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAABiUlEQVQ4y41T207CQBDt5/gVfox/4KM/4DeQGCIvxCcefPPJB4NgYlSM5VZKS2kLWLcItFJK2z3uLhe5CpPOTjOZnJ09Z0aqVJt4yL+g+PSOQvEVpVIJmqah0WjAsixQSsFtEQ+ZNHAe4WhZEOMGbvcehLhwCYHjOHBdF0mcCLAkSY4Cl0B7rEIBEuboHOxgFXTXBRL/XTo7En6wTx8N4Xh96E0Nvc8e2u32sstNXwWVZslk7lSg8qCW3iCX80ilrpDJXCOXy+186iaotPUcOotfto2mqkJvtaDOBVIUBSrL8W65cIZhbFEh7ePHdT10bALb6sA0TdjsAg60ANN1XcTRaLTW6V7ACjHw3K3jZxpsEb9ax3ldAxRJIcZfYcz4vFULSMt3IOPBwVFZU3klfdTI/KfyskOzT2F/s87iGFEUiTiNppiEE+HBeCxyx2yMFEYUp5fAyQWFXG2gLH+gVqtDlmUhBmFbwzcmDMPjAc+zwFmaKTvw4bGB9jwPw+EQvu8jCIKdXO2zX22p65M+4+F5AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Slack Invite Mail",
        "title": "Slack Invite Mail",
        "src": "/ibm-cloudnative-journey/static/c4cbd2f09b1d8fb96d9b87dc0936b69d/3cbba/SlackInviteMail.png",
        "srcSet": ["/ibm-cloudnative-journey/static/c4cbd2f09b1d8fb96d9b87dc0936b69d/7fc1e/SlackInviteMail.png 288w", "/ibm-cloudnative-journey/static/c4cbd2f09b1d8fb96d9b87dc0936b69d/a5df1/SlackInviteMail.png 576w", "/ibm-cloudnative-journey/static/c4cbd2f09b1d8fb96d9b87dc0936b69d/3cbba/SlackInviteMail.png 1152w", "/ibm-cloudnative-journey/static/c4cbd2f09b1d8fb96d9b87dc0936b69d/0b124/SlackInviteMail.png 1728w", "/ibm-cloudnative-journey/static/c4cbd2f09b1d8fb96d9b87dc0936b69d/4ea69/SlackInviteMail.png 2304w", "/ibm-cloudnative-journey/static/c4cbd2f09b1d8fb96d9b87dc0936b69d/a989c/SlackInviteMail.png 2530w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ul>
      <li parentName="ul">{`Once you click on this link, it will redirect to the login page where you need to login with your guest-id.`}</li>
      <li parentName="ul">{`Search for your slack channel name (the name would be shared prior) and join it.`}</li>
    </ul>
    <p><strong parentName="p">{`NOTE`}</strong>{`: If you did not get the invite, reply back to the invite email and inform us.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      